"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPosition = exports.ButtonRole = exports.ButtonType = exports.ButtonSize = exports.TextColor = exports.ButtonColor = void 0;
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["ALTERNATE"] = "alternate";
    ButtonColor["BLUE"] = "blue";
    ButtonColor["GREEN"] = "green";
    ButtonColor["PRIMEGREEN"] = "primegreen";
    ButtonColor["EMERALDGREEN"] = "emeraldgreen";
    ButtonColor["ORANGE"] = "orange";
    ButtonColor["WHITE"] = "white";
    ButtonColor["TRANSPARENT"] = "transparent";
    ButtonColor["COBALT"] = "cobalt";
})(ButtonColor = exports.ButtonColor || (exports.ButtonColor = {}));
var TextColor;
(function (TextColor) {
    TextColor["CONTRASTBLUE"] = "contrastBlue";
})(TextColor = exports.TextColor || (exports.TextColor = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["LARGE"] = "large";
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["SMALL"] = "small";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["GHOST"] = "ghost";
    ButtonType["PRIMARY"] = "primary";
    ButtonType["SQUARE"] = "square";
    ButtonType["TEXT"] = "text";
    ButtonType["SIMPLE_TEXT"] = "simpletext";
    ButtonType["GHOST_SQUARE"] = "ghost-square";
    ButtonType["BLACK"] = "black";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var ButtonRole;
(function (ButtonRole) {
    ButtonRole["BUTTON"] = "button";
    ButtonRole["LINK"] = "link";
})(ButtonRole = exports.ButtonRole || (exports.ButtonRole = {}));
var IconPosition;
(function (IconPosition) {
    IconPosition["LEFT"] = "left";
    IconPosition["RIGHT"] = "right";
})(IconPosition = exports.IconPosition || (exports.IconPosition = {}));
//# sourceMappingURL=ButtonProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Button/ButtonProps.js
// module id = 26
// module chunks = 8